import React, { useMemo, useState } from "react";
import ComponentCustomModal from "../../components/common/customModal/ComponentCustomModal";
import useDataInputOption from "../../hooks/useDataInputOption";
import { FtextField } from "../../components/common/FtextField";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import Loader from "../../components/common/Loader";
import { useDispatch, useSelector } from "react-redux";
import useISPowner from "../../hooks/useISPOwner";
import { createNetworkPoint } from "../../features/oltApi";

const NetworkDialog = ({ show, setShow, isUpdate, networkPoint }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //---> Get user & current user data form useISPOwner hooks
  const { ispOwnerId } = useISPowner();

  //---> Get netwok device from redux store
  const devices = useSelector((state) => state.network?.devices);

  const extraInputOptions = [
    {
      name: "device",
      as: "select",
      type: "select",
      id: "device",
      disabled: false,
      validation: true,
      isVisible: isUpdate ? false : true,
      label: t("device"),
      firstOptions: t("selectDevice"),
      textAccessor: "name",
      valueAccessor: "id",
      options: devices,
    },
    {
      name: "description",
      as: "textarea",
      type: "textarea",
      id: "description",
      isVisible: true,
      disabled: false,
      validation: false,
      label: t("description"),
    },
  ];

  // call the data input option function
  const inputPermission = {
    name: true,
    area: true,
    subArea: true,
    poleBox: true,
    device: true,
    description: true,
  };

  // get data input option from useDataInputOption hook
  const dataInputOption = useDataInputOption(
    inputPermission,
    null,
    null,
    isUpdate ? networkPoint : null,
    extraInputOptions
  );

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);

  const visibleInputFields = useMemo(() => {
    if (!dataInputOption?.inputOption) return [];

    const optionMap = dataInputOption.inputOption.reduce((acc, option) => {
      acc[option.name] = option;
      return acc;
    }, {});

    return Object.keys(inputPermission)
      .map((field) => optionMap[field])
      .filter((item) => item && item.isVisible);
  }, [dataInputOption, inputPermission]);

  const handleNetworkPointCreationFormSubmission = (formValues) => {
    const sendingData = {
      ...formValues,
      ispOwner: ispOwnerId,
    };

    createNetworkPoint(dispatch, sendingData, setIsLoading, setShow);
  };

  return (
    <>
      <ComponentCustomModal
        {...{
          show,
          setShow,
          header: t("network"),
          footer: (
            <div className="displayGrid1 float-end">
              <button
                type="button"
                className="btn btn-secondary border-0"
                disabled={isLoading}
                onClick={() => setShow(false)}
              >
                {t("cancel")}
              </button>

              <button
                type="submit"
                form="networkForm"
                className="btn btn-success border-0"
                disabled={isLoading}
              >
                {isLoading ? <Loader /> : t("submit")}
              </button>
            </div>
          ),
        }}
      >
        <Formik
          initialValues={dataInputOption.inputInitialValues}
          onSubmit={(values) => {
            handleNetworkPointCreationFormSubmission(values);
          }}
          enableReinitialize
        >
          {() => (
            <Form id="networkForm">
              <div className="displayGrid">
                {visibleInputFields?.map(
                  (item) =>
                    item?.isVisible && <FtextField key={item.name} {...item} />
                )}
              </div>
            </Form>
          )}
        </Formik>
      </ComponentCustomModal>
    </>
  );
};

export default NetworkDialog;
